import { ResourceTarget } from "@/services/cloudchipr.api";
import { TaskOpportunityTarget } from "@/store/task-management/utils/types/types";

export const isKubernetesOpportunityTarget = (
  opportunity: ResourceTarget | TaskOpportunityTarget,
) => {
  return "cluster" in opportunity;
};
